import React from 'react'
import Button from '@material-ui/core/Button/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup/ButtonGroup'
import FormControl from '@material-ui/core/FormControl/FormControl'
import Select from '@material-ui/core/Select/Select'
import Typography from '@material-ui/core/Typography/Typography'
import { strings } from '../../../localization/strings'

const createRange = (page, pageCount, size) => {
    let range
    let medium = parseInt(size / 2)
    if (page <= medium) {
        range = { start: 1, end: size }
    }
    if (page >= pageCount - medium) {
        range = { start: pageCount - size + 1, end: pageCount }
    }
    if (!range) {
        range = { start: page - medium, end: page + medium }
    }

    range.array = []
    while (range.start <= range.end) {
        if (range.start >= 1) range.array.push(range.start)
        range.start++
    }
    return range.array
}

class Component extends React.Component {
    state = {}

    render() {
        const buttonActions = {
            first: '<<',
            prev: null,
            next: null,
            last: '>>',
        }
        const {
            pageButtons,
            rowCount,
            pageIndex,
            onChangePage,
            rowsPerPage,
            rowsPerPageOptions,
            onChangeRowsPerPage,
        } = this.props
        if (
            !pageButtons ||
            !rowCount ||
            !pageIndex ||
            !onChangePage ||
            !rowsPerPage ||
            !rowsPerPageOptions ||
            !onChangeRowsPerPage
        )
            return null

        const pageCount =
            parseInt(rowCount / rowsPerPage, 10) +
            (rowCount % rowsPerPage > 0 ? 1 : 0)
        const pageRange = createRange(pageIndex, pageCount, pageButtons)

        return (
            <div
                style={{
                    ...this.props.style,
                    display: 'flex',
                    justifyContent: 'space-around',
                    flexWrap: 'wrap',
                    padding: 4,
                }}
            >
                <div
                    style={{
                        minWidth: 300,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'baseline',
                    }}
                >
                    <Typography variant={'body1'}>
                        {this.props.rowLabel}
                    </Typography>
                    <FormControl style={{ marginLeft: 8 }}>
                        <Select
                            // variant={"standard"}
                            native
                            value={rowsPerPage}
                            onChange={(e) =>
                                onChangeRowsPerPage(e.target.value)
                            }
                        >
                            {rowsPerPageOptions.map((x) => (
                                <option key={x + ''} value={x}>
                                    {x}
                                </option>
                            ))}
                        </Select>
                    </FormControl>
                    <Typography variant={'body1'} style={{ marginLeft: 8 }}>
                        {strings.paginatorRowsPerPage}
                    </Typography>
                </div>
                <div
                    style={{
                        minWidth: 300,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'baseline',
                    }}
                >
                    <Typography variant={'body1'}>
                        {this.props.recordCountLabel
                            ? this.props.recordCountLabel.replace(
                                  '{{count}}',
                                  rowCount
                              )
                            : null}
                    </Typography>
                </div>

                <ButtonGroup
                    style={{ marginLeft: 4 }}
                    size="small"
                    aria-label="small outlined button group"
                >
                    {!buttonActions.first ? null : (
                        <Button
                            disabled={pageIndex === 1}
                            onClick={() => onChangePage(1)}
                        >
                            {buttonActions.first}
                        </Button>
                    )}

                    {!buttonActions.prev ? null : (
                        <Button
                            disabled={pageIndex === 1}
                            onClick={() =>
                                onChangePage(pageIndex > 1 ? pageIndex - 1 : 1)
                            }
                        >
                            {buttonActions.prev}
                        </Button>
                    )}

                    {pageRange.map((x) => (
                        <Button
                            key={x + ''}
                            variant={x !== pageIndex ? undefined : 'contained'}
                            color={x !== pageIndex ? undefined : 'primary'}
                            onClick={() => onChangePage(x)}
                        >
                            {x}
                        </Button>
                    ))}

                    {!buttonActions.next ? null : (
                        <Button
                            disabled={pageIndex === pageCount}
                            onClick={() =>
                                onChangePage(
                                    pageIndex < pageCount
                                        ? pageIndex + 1
                                        : pageCount
                                )
                            }
                        >
                            {buttonActions.next}
                        </Button>
                    )}

                    {!buttonActions.last ? null : (
                        <Button
                            disabled={pageIndex === pageCount}
                            onClick={() => onChangePage(pageCount)}
                        >
                            {buttonActions.last}
                        </Button>
                    )}
                </ButtonGroup>
            </div>
        )
    }
}

export default Component
